import { useEffect, useState } from 'react';

const loadImageFromURL = (url) => {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject();
    img.src = url;
  });
};

const useImage = (imageURL) => {
  const [image, setImage] = useState(null);
  const [imageIsLoading, setImageIsLoading] = useState(false);

  useEffect(() => {
    const loadImage = async () => {
      const img = await loadImageFromURL(imageURL);
      setImage(img);
      setImageIsLoading(false);
    };

    setImageIsLoading(true);
    if (imageURL) {
      loadImage();
    } else {
      setImage(null);
      setImageIsLoading(false);
    }
  }, [imageURL]);

  return [image, imageIsLoading];
};

export { useImage };
